import {useQuery} from '@tanstack/react-query';

import api from 'utils/api';

import playlistKeys from './queryKeys';

function useFetchPlaylists(teamId) {
	async function fetchPlaylists() {
		const {list} = await api('get', '/api/playlists', {
			teamId,
		});
		return list;
	}

	const {data = [], ...result} = useQuery({
		queryKey: playlistKeys.playlists(teamId),
		queryFn: fetchPlaylists,
		staleTime: 5 * 60 * 1000,
	});

	return {
		...result,
		playlists: data,
	};
}

export default useFetchPlaylists;
